export default function () {
  const sliderButtons = [].slice.call( document.querySelectorAll("button[data-slider]"));
  if (sliderButtons) {
    sliderButtons.forEach(button => {
      const sliderToChange = document.getElementById(button.dataset.slider);
      if (sliderToChange) {
        button.onclick = () => {
          const sliderButton = sliderToChange.querySelector(`button[aria-label="${button.dataset.label}"]`);
          if (sliderButton) {
            sliderButton.click();
          }
        }
      }
    })
  }
  const sliderDots = [].slice.call( document.querySelectorAll("[data-dot]"));
  if (sliderDots) {
    sliderDots.forEach(button => {
      const sliderToChange = document.getElementById(button.dataset.slider);
      if (sliderToChange) {
        button.onclick = () => {
          sliderToChange.slick.slickGoTo(button.dataset.dot);
        }
      }
    })
  }
}
